import { Card } from "../components/Card";
import { DashProgress } from "../components/Dash";
import { MilestoneBulkBar, MilestoneForm, MilestoneIssueList } from "../components/Milestones";
import type { Milestone } from "../lib/tasks";
import { ISSUES } from "../mock/issues";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 마일스톤의 부품 ══
   견본 이슈로 체크 목록 · 넣기/빼기 막대 · 새 마일스톤 폼(기본 · 오류)을 세운다. 단추는 서버를 안 부른다. */

const MS: Milestone = { id: "m9-design", title: "M9 디자인", orderRank: 1, taskCount: 6, doneCount: 2, projectId: null, goal: "공통 v3 로 화면을 옮긴다" }; // copy-ignore: 견본 마일스톤 데이터
const FAKE = {
  createMilestone: async () => MS,
  setMilestone: async () => ISSUES[0],
};

export function MilestoneStates() {
  const noop = () => undefined;
  const inMs = ISSUES.slice(0, 2).map((t) => ({ ...t, milestoneId: MS.id }));
  const rest = ISSUES.slice(2).map((t) => ({ ...t, milestoneId: null }));
  const list = [...inMs, ...rest];
  const picked = new Set([inMs[0].id, rest[0].id, rest[1].id]);
  return (
    <>
      <h3>{tx("pat.ms.info")}</h3>
      <div className="pat__grid">
        <Card title={MS.title}>
          <DashProgress done={MS.doneCount} total={MS.taskCount} label={tx("milestones.progress")} />
        </Card>
        <Card title="empty">
          <DashProgress done={0} total={0} label={tx("milestones.progress")} />
        </Card>
      </div>
      <h3>{tx("pat.ms.list")}</h3>
      <MilestoneIssueList ms={MS} list={list} project={null} picked={picked} onPick={noop} />
      <MilestoneIssueList ms={MS} list={[]} project={null} picked={new Set()} onPick={noop} />
      <h3>{tx("pat.ms.bulk")}</h3>
      <MilestoneBulkBar ms={MS} picked={list.filter((t) => picked.has(t.id))} onDone={noop} onClear={noop} api={FAKE} />
      <h3>{tx("pat.ms.form")}</h3>
      <div className="pat__grid">
        <MilestoneForm projects={[]} onCancel={noop} onCreated={noop} api={FAKE} />
        <MilestoneForm projects={[]} onCancel={noop} onCreated={noop} api={FAKE} initialError="milestone id exists (HTTP 409)" />
      </div>
    </>
  );
}
